(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class PivotCollectionTabs extends HTMLElement {
    connectedCallback() {
      this.$tabs = this.querySelectorAll('.pvt-collection-tabs-menu .button');

      this.$tabs.forEach((button) => {
        console.log('Button', button);
        button.addEventListener('click', (e) => {
          const activeButton = this.querySelector('.pvt-collection-tabs-menu .button:not(.button-secondary)');
          if (activeButton === button) return;

          const activeSection = this.querySelector('.pvt-collection-tabs__section.is-active');
          const targetSection = this.querySelector(
            `.pvt-collection-tabs__section[data-block="${button.dataset.block}"]`
          );
          if (!targetSection) return;

          activeSection.classList.remove('is-active');
          activeButton.classList.add('button-secondary');

          // Buttons
          activeSection.setAttribute('aria-hidden', 'true');
          targetSection.setAttribute('aria-hidden', 'false');
          targetSection.classList.add('is-active');
          button.classList.remove('button-secondary');
        });
      });
    }
  }

  if (!customElements.get('pivot-collection-tabs')) {
    customElements.define('pivot-collection-tabs', PivotCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class PivotShopTheLook extends HTMLElement {
    connectedCallback() {
      this.$carousel = this.querySelector('slideshow-component');
      this.indicators = this.querySelectorAll('.pivot-shop-the-look__indicator, .pvt-bstl__indicator');

      this.$imageBlock = this.querySelector('.pvt-image-block');
      this.$imageBlock.addEventListener('click', () => {
        this.indicators.forEach(($button) => ($button.closest('details').open = false));
      });

      const observer = new MutationObserver((entries) =>
        entries.forEach((entry) => {
          const $slide = this.querySelector(
            `.pivot-shop-the-look__block[data-product="${entry.target.dataset.product}"]`
          );
          $slide.classList.toggle('is-active', entry.target.open);
        })
      );

      this.indicators.forEach(($button) => {
        $button.addEventListener('click', () => {
          this.$carousel.select($button.dataset.id);
        });

        observer.observe($button.closest('details'), {
          attributes: true,
          attributeFilter: ['open'],
        });
      });
    }
  }
  if (!customElements.get('pivot-shop-the-look')) {
    customElements.define('pivot-shop-the-look', PivotShopTheLook);
  }

  // Lógica del botón
  class PivotShopTheLookButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.originalText = this.button.textContent;
      this.addEventListener('click', this.handleClick.bind(this));
    }

    async handleClick(event) {
      event.preventDefault();

      // Disable button and show loading state
      this.button.setAttribute('disabled', true);
      this.button.classList.add('loading');
      this.button.innerHTML = '<span class="loading-spinner"></span> Añadiendo...';

      try {
        // Get all product blocks in the current shop-the-look section
        const parentSection = this.closest('pivot-shop-the-look');
        const productBlocks = parentSection.querySelectorAll('.pivot-shop-the-look__block[data-product-variant]');

        if (!productBlocks.length) {
          console.warn('No se encontraron productos para añadir al carrito');
          this.showError('No hay productos disponibles');
          return;
        }

        // Build items array for the cart API
        const items = [];
        productBlocks.forEach((block) => {
          const variantId = block.getAttribute('data-product-variant');
          if (variantId) {
            items.push({
              id: Number(variantId),
              quantity: 1,
            });
          }
        });

        if (!items.length) {
          console.warn('No se encontraron variantes válidas para añadir al carrito');
          this.showError('No hay variantes disponibles');
          return;
        }

        // Get section IDs to update
        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionsToUpdate = new Set(['cart-drawer']);
        cartItemsComponents.forEach((item) => {
          if (item instanceof HTMLElement && item.dataset.sectionId) {
            sectionsToUpdate.add(item.dataset.sectionId);
          }
        });

        // Add items to cart using Shopify Ajax API
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items,
            sections: Array.from(sectionsToUpdate).join(','),
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Error al añadir al carrito');
        }

        // Success! Process response and update cart
        const result = await response.json();

        // Show success state
        this.button.classList.remove('loading');
        this.button.classList.add('success');
        this.button.innerHTML = '<span>✓</span> ¡Añadido!';

        // Dispatch cart:update event for the theme to handle cart drawer updates
        // Using CustomEvent but with the same structure as CartAddEvent
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: 'shop-the-look-button',
              data: {
                source: 'shop-the-look-component',
                itemCount: items.length,
                sections: result.sections,
              },
            },
          })
        );

        // Reset button after a delay
        setTimeout(() => {
          this.button.removeAttribute('disabled');
          this.button.classList.remove('success');
          this.button.textContent = this.originalText;
        }, 2000);
      } catch (error) {
        console.error('Error al añadir productos al carrito:', error);
        this.showError('Error al añadir al carrito');
      }
    }

    showError(message) {
      this.button.classList.remove('loading');
      this.button.classList.add('error');
      this.button.textContent = message;

      setTimeout(() => {
        this.button.removeAttribute('disabled');
        this.button.classList.remove('error');
        this.button.textContent = this.originalText;
      }, 3000);
    }
  }

  if (!customElements.get('pivot-shop-the-look-button')) {
    customElements.define('pivot-shop-the-look-button', PivotShopTheLookButton);
  }

  } catch(e) { console.error(e); }
})();
})();
